import {
  DomainAPI,
  Channel,
  generateKey,
  APIKey,
  Authorization,
  SecretApiKey,
  SecretApiKeyExpires,
} from "../utils/setting";
import jwt from "jsonwebtoken";
import { checkResponse } from "../utils/checkResponse";
import {
  getAlbumForRole,
  deleteImage,
  listFiles,
  upload,
  uploadFolder,
  remove,
  rename,
} from "../api/albums";
import { getDownloadUrl } from "../utils/storage";
const album = {
  state: {
    serviceAlbum: [],
    allImage: [],
    total: 0,
    list: [],
  },
  reducers: {
    setState(state, payload) {
      this.state = { ...state, ...payload };
      return { ...this.state };
    },
    addNewFolder(state, folder) {
      const list = state.list;
      state.list = [...list, folder];
      return { ...state };
    },
    addNewFiles(state, file) {
      const list = state.list;
      state.list = [...list, file];
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async getAlbumForRole(payload = {}, rootState) {
      const response = await getAlbumForRole();
      if (response.code !== 1) {
        return null;
      }
      const list = response.data.map((item) => {
        const originalFilename = item.originalFilename
          ? item.originalFilename
          : "";
        return {
          code: item.code,
          key: item.path + originalFilename,
          url: item.imageUrl || "",
          download: getDownloadUrl(item.imageUrl),
          thumbnail: item.thumbnailUrl || "",
          size: item.size,
          createdAt: item.createdAt || null,
          name: item.originalFilename || "",
          path: item.path,
        };
      });
      this.setState({
        list,
      });
    },

    async deleteImageStorage(payload = {}, rootState) {
      const response = await deleteImage(payload);
      checkResponse(response, dispatch);
      if (
        response &&
        response.code === 1 &&
        String(payload.key) &&
        String(payload.index)
      ) {
        let { allImage, total } = rootState.album;
        if (
          allImage &&
          allImage[payload.key] &&
          allImage[payload.key][payload.index]
        ) {
          allImage[payload.key].splice(payload.index, 1);
          this.setState({ allImage: allImage, total: total - 1 });
        }
      }
      return response;
    },
    async createAlbumForRole(payload = {}, rootState) {
      let url = DomainAPI + Channel + "/api/secure/albums/createAlbumForRole";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    async deleteImageAlbum(payload = {}, rootState) {
      let url = DomainAPI + Channel + "/api/secure/albums/deleteItemAlbum";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    async listFiles(payload, rootState) {
      try {
        const response = await listFiles();
        if (response.code !== 1) {
          return null;
        }
        this.setState({ list: response.data });
        return true;
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    uploadFile(payload, rootState) {
      return upload(payload);
    },
    uploadFolder(payload, rootState) {
      return uploadFolder(payload);
    },
    remove(payload, rootState) {
      return remove(payload);
    },
    rename(payload, rootState) {
      return rename(payload);
    },
  }),
};

export default album;
